import { render, staticRenderFns } from "./ApiEnumForces.vue?vue&type=template&id=5fabf121&scoped=true&"
import script from "./ApiEnumForces.vue?vue&type=script&lang=js&"
export * from "./ApiEnumForces.vue?vue&type=script&lang=js&"
import style0 from "./ApiEnumForces.vue?vue&type=style&index=0&id=5fabf121&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fabf121",
  null
  
)

export default component.exports